import React from 'react';
import Layout from '../components/layout/Layout';
import AlzheimerReportForm from '../components/reports/AlzheimerReportForm';

const AlzheimerReportPage = () => {
  return (
    <Layout>
      <AlzheimerReportForm />
    </Layout>
  );
};

export default AlzheimerReportPage;
